import React from "react";
import moment from "moment";
import { RadioButtonGroup, RadioButton, FlatButton } from "material-ui";
import set from "lodash/set";
import juration from "juration";

import BaseOverlay from "./base.jsx";

import DurationField from "../duration-field.jsx";
import DateTimeField from "../datetime-field.jsx";

class GodTicketsExtension extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "unlock",
      mode: "fromNow",
      length: juration.parse("7 days") * 1000,
      date: moment().add(7, "days")
    };
  }

  onChange = (id, value) => {
    this.setState({
      [id]: value
    });
  };

  submitExtension = () => {
    this.props.submit(this.state);
  };

  render() {
    const { type, mode, length, date } = this.state;
    const { ticketsLength, open, submitting, onClose } = this.props;

    return (
      <BaseOverlay
        open={open}
        onRequestClose={onClose}
        hideTitleAndFooterBorders={true}
        showCloseButton={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={onClose} />,
          <FlatButton
            primary={true}
            disabled={submitting}
            label={submitting ? "Submitting extension..." : "Submit extension"}
            onTouchTap={this.submitExtension}
          />
        ]}
      >
        <h2>
          Extend {ticketsLength} ticket{ticketsLength !== 1 ? "s" : ""}
        </h2>
        <div style={{ marginTop: 20 }}>
          <h3>Extension type</h3>
          <RadioButtonGroup
            name="extensionType"
            valueSelected={type}
            onChange={(e, v) => this.onChange("type", v)}
          >
            <RadioButton value="unlock" label="Unlock window" />
            <RadioButton value="watch" label="Watch window" />
          </RadioButtonGroup>
        </div>
        <div style={{ marginTop: 20 }}>
          <h3>Extension mode</h3>
          <RadioButtonGroup
            name="extensionMode"
            valueSelected={mode}
            onChange={(e, v) => this.onChange("mode", v)}
          >
            <RadioButton value="fromNow" label="Add time from now" />
            <RadioButton
              value="fromCurrent"
              label={`Add time from current ${
                type === "unlock" ? "unlock" : "watch expiry"
              } time`}
            />
            <RadioButton
              value="fromUsedAt"
              label={`Add time from when scanned/"Watch now" clicked`}
            />
            <RadioButton value="absolute" label="Set absolute date" />
          </RadioButtonGroup>
        </div>
        <div style={{ marginTop: 20 }}>
          <h3 style={{ marginBottom: -10 }}>
            Extension {mode === "absolute" ? "date" : "length"}
          </h3>
          {mode === "absolute" ? (
            <DateTimeField
              value={date}
              useMoment={true}
              unclearable={true}
              onChange={(e, v) => this.onChange("date", v)}
              style={{ display: "inline-block" }}
            />
          ) : (
            <DurationField
              value={length}
              floatingLabelFixed={false}
              onChange={e => this.onChange("length", e.target.value)}
            />
          )}
        </div>
      </BaseOverlay>
    );
  }
}

export default GodTicketsExtension;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/god-tickets-extension.jsx